module.exports = __webpack_public_path__ + "img/H-B-3-unload-standup-shadow.e014850f.png";